function n(t) {
  return t.composedPath()[0];
}
export {
  n as getEventTarget
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/evtd@0.2.4/~/evtd/es/utils.js
// module id = 897
// module chunks = 67